export const TUTORIAL_CONFIG = {
  CURRENT_VERSION: "0.1",
};
